/* ===========================================================
   Vibralivo theme – interactions & AJAX cart
   =========================================================== */
(function () {
  "use strict";

  var FREE_SHIP_THRESHOLD = (window.theme && window.theme.freeShipCents) || 4900;

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(window.theme.locale || "de-DE", {
        style: "currency",
        currency: window.theme.currency || "EUR",
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + " " + (window.theme.currency || "");
    }
  }

  /* ---------- header scroll ---------- */
  var header = $(".site-header");
  if (header) {
    var onScroll = function () {
      header.classList.toggle("is-scrolled", window.scrollY > 8);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---------- mobile menu ---------- */
  var menuToggle = $("[data-menu-toggle]");
  var mobileNav = $("[data-mobile-nav]");
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener("click", function () {
      mobileNav.classList.toggle("is-open");
    });
  }

  /* ---------- cart drawer ---------- */
  var overlay = $("[data-cart-overlay]");
  var drawer = $("[data-cart-drawer]");

  function openDrawer() {
    if (overlay) overlay.classList.add("is-open");
    if (drawer) drawer.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }
  function closeDrawer() {
    if (overlay) overlay.classList.remove("is-open");
    if (drawer) drawer.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  $all("[data-cart-open]").forEach(function (b) {
    b.addEventListener("click", function (e) { e.preventDefault(); refreshCart().then(openDrawer); });
  });
  $all("[data-cart-close]").forEach(function (b) {
    b.addEventListener("click", closeDrawer);
  });
  if (overlay) overlay.addEventListener("click", closeDrawer);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });

  /* ---------- update cart count bubbles ---------- */
  function updateCount(count) {
    $all("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  /* ---------- render drawer from cart object ---------- */
  function renderDrawer(cart) {
    var body = $("[data-drawer-body]");
    if (!body) return;
    updateCount(cart.item_count);

    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="drawer__empty">' +
        '<div class="ico">' + icon("bag", 36) + "</div>" +
        "<p class=\"text-muted\">" + (window.theme.strings.cartEmpty || "Dein Warenkorb ist leer.") + "</p>" +
        '<a href="' + window.theme.routes.cart + '" class="btn btn--primary">' + (window.theme.strings.discover || "Jetzt entdecken") + "</a>" +
        "</div>";
      return;
    }

    var remaining = Math.max(0, FREE_SHIP_THRESHOLD - cart.total_price);
    var progress = Math.min(100, (cart.total_price / FREE_SHIP_THRESHOLD) * 100);

    var lines = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '">'
        : placeholder();
      return (
        '<div class="cart-line" data-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="cart-line__media">' + img + "</a>" +
        '<div class="cart-line__body">' +
        '<div class="cart-line__top">' +
        '<span class="cart-line__title">' + escapeHtml(item.product_title) + "</span>" +
        '<button class="cart-line__remove" data-remove="' + item.key + '" aria-label="' + (window.theme.strings.remove || "Entfernen") + '">' + icon("trash", 16) + "</button>" +
        "</div>" +
        '<div class="cart-line__sub">' + formatMoney(item.final_price) + "</div>" +
        '<div class="cart-line__foot">' +
        '<div class="qty qty--sm">' +
        '<button data-change="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Weniger">' + icon("minus", 14) + "</button>" +
        "<span>" + item.quantity + "</span>" +
        '<button data-change="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Mehr">' + icon("plus", 14) + "</button>" +
        "</div>" +
        '<strong style="font-size:.9rem">' + formatMoney(item.final_line_price) + "</strong>" +
        "</div></div></div>"
      );
    }).join("");

    body.innerHTML =
      '<div class="drawer__progress">' +
      "<p>" +
      (remaining > 0
        ? (window.theme.strings.freeShipPre || "Nur noch") + ' <strong style="color:var(--brand-300)">' + formatMoney(remaining) + "</strong> " + (window.theme.strings.freeShipPost || "bis zum Gratis-Versand 🚚")
        : '<strong style="color:var(--brand-300)">' + (window.theme.strings.freeShipReached || "🎉 Glückwunsch, du hast Gratis-Versand!") + "</strong>") +
      "</p>" +
      '<div class="bar"><span style="width:' + progress + '%"></span></div>' +
      "</div>" +
      '<div class="drawer__items">' + lines + "</div>" +
      '<div class="drawer__foot">' +
      '<div class="drawer__subtotal"><span>' + (window.theme.strings.subtotal || "Zwischensumme") + "</span><strong>" + formatMoney(cart.total_price) + "</strong></div>" +
      '<a href="' + window.theme.routes.cart + '/checkout" class="btn btn--primary btn--block">' + (window.theme.strings.checkout || "Zur Kasse") + "</a>" +
      '<button class="btn btn--block" style="margin-top:.5rem;color:var(--w50)" data-cart-close>' + (window.theme.strings.continueShopping || "Weiter einkaufen") + "</button>" +
      "</div>";

    bindDrawerEvents();
  }

  function bindDrawerEvents() {
    $all("[data-remove]").forEach(function (b) {
      b.addEventListener("click", function () { changeItem(b.getAttribute("data-remove"), 0); });
    });
    $all("[data-change]").forEach(function (b) {
      b.addEventListener("click", function () {
        changeItem(b.getAttribute("data-change"), parseInt(b.getAttribute("data-qty"), 10));
      });
    });
    $all("[data-cart-close]", drawer).forEach(function (b) {
      b.addEventListener("click", closeDrawer);
    });
  }

  /* ---------- AJAX cart API ---------- */
  function refreshCart() {
    return fetch(window.theme.routes.cart + ".js", { headers: { "Content-Type": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderDrawer(cart); return cart; });
  }

  function addItem(id, qty) {
    return fetch(window.theme.routes.cart_add + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] }),
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCart(); })
      .then(function () { openDrawer(); });
  }

  function changeItem(key, qty) {
    return fetch(window.theme.routes.cart_change + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderDrawer(cart);
        if (document.body.classList.contains("template-cart")) window.location.reload();
      });
  }

  /* ---------- bind "add to cart" buttons (cards) ---------- */
  $all("[data-add-to-cart]").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      var id = btn.getAttribute("data-variant-id");
      if (!id) return;
      btn.disabled = true;
      addItem(id, 1).finally(function () { btn.disabled = false; });
    });
  });

  /* ---------- product form ---------- */
  var productForm = $("[data-product-form]");
  if (productForm) {
    productForm.addEventListener("submit", function (e) {
      e.preventDefault();
      var id = $("[name='id']", productForm).value;
      var qtyEl = $("[name='quantity']", productForm);
      var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
      var submit = $("[type='submit']", productForm);
      if (submit) submit.disabled = true;
      addItem(id, qty).finally(function () { if (submit) submit.disabled = false; });
    });
  }

  /* ---------- product variant picker (image / price / availability) ---------- */
  function initVariantPicker() {
    var form = $("[data-variant-picker]");
    if (!form) return;
    var dataEl = $("[data-variant-json]", form);
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = $("[data-variant-id-input]", form);
    var optionGroups = $all("[data-option]", form);
    var mainImage = $("[data-main-image]");
    var thumbs = $all("[data-thumb]");

    function selectedOptions() {
      return optionGroups.map(function (group) {
        var checked = $("input[type='radio']:checked", group);
        return checked ? checked.value : null;
      });
    }

    function matchVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (String(v.options[j]) !== String(opts[j])) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function setMainImage(src, imageId) {
      if (!mainImage || !src) return;
      mainImage.src = src;
      thumbs.forEach(function (t) {
        t.classList.toggle("is-active", imageId != null && t.getAttribute("data-image-id") === String(imageId));
      });
    }

    function updatePrice(v) {
      var cur = $("[data-price-current]", form.closest(".product") || document);
      var cmp = $("[data-price-compare]");
      var save = $("[data-price-save]");
      var saveBadge = $("[data-price-save-badge]");
      if (cur) cur.textContent = formatMoney(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (cmp) { cmp.textContent = formatMoney(v.compare_at_price); cmp.hidden = !onSale; }
      if (onSale) {
        var disc = Math.round((1 - v.price / v.compare_at_price) * 100);
        if (save) { save.textContent = "Spare " + disc + "%"; save.hidden = false; }
        if (saveBadge) { saveBadge.textContent = "-" + disc + "%"; saveBadge.hidden = false; }
      } else {
        if (save) save.hidden = true;
        if (saveBadge) saveBadge.hidden = true;
      }
    }

    function updateAvailability(v) {
      var btn = $("[data-add-submit]", form);
      var label = $("[data-add-label]", form);
      if (!btn) return;
      if (v && v.available) {
        btn.disabled = false;
        if (label) label.textContent = window.theme.strings.addToCart || "In den Warenkorb";
      } else {
        btn.disabled = true;
        if (label) label.textContent = v ? (window.theme.strings.soldOut || "Ausverkauft") : (window.theme.strings.unavailable || "Nicht verfügbar");
      }
    }

    function update() {
      var opts = selectedOptions();
      // update the selected-value labels
      optionGroups.forEach(function (group) {
        var checked = $("input[type='radio']:checked", group);
        var out = $("[data-option-selected]", group);
        if (checked && out) out.textContent = checked.value;
      });
      var v = matchVariant(opts);
      if (!v) { updateAvailability(null); return; }
      if (idInput) idInput.value = v.id;
      updatePrice(v);
      updateAvailability(v);
      if (v.image) setMainImage(v.image, v.image_id);
    }

    $all("input[type='radio'][name^='option-']", form).forEach(function (r) {
      r.addEventListener("change", update);
    });

    // clicking a thumbnail shows that image
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        setMainImage(t.getAttribute("data-image-src"), t.getAttribute("data-image-id"));
      });
    });

    update();
  }
  initVariantPicker();

  /* ---------- quantity steppers (product page) ---------- */
  $all("[data-qty-wrap]").forEach(function (wrap) {
    var input = $("input", wrap);
    $all("[data-qty-step]", wrap).forEach(function (b) {
      b.addEventListener("click", function () {
        var step = parseInt(b.getAttribute("data-qty-step"), 10);
        var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = val;
      });
    });
  });

  /* ---------- collection filter chips (client-side) ---------- */
  $all("[data-filter]").forEach(function (chip) {
    chip.addEventListener("click", function () {
      var val = chip.getAttribute("data-filter");
      $all("[data-filter]").forEach(function (c) { c.classList.toggle("is-active", c === chip); });
      var shown = 0;
      $all("[data-product-item]").forEach(function (item) {
        var match = val === "all" || (item.getAttribute("data-tags") || "").indexOf(val) > -1;
        item.style.display = match ? "" : "none";
        if (match) shown++;
      });
      var count = $("[data-result-count]");
      if (count) count.textContent = shown + " Produkte";
    });
  });

  /* ---------- newsletter inline success (cosmetic) ---------- */
  $all("[data-newsletter]").forEach(function (form) {
    form.addEventListener("submit", function () {
      var btn = $("[type='submit']", form);
      if (btn) setTimeout(function () { btn.textContent = "Angemeldet ✓"; }, 50);
    });
  });

  /* ---------- inline icons used by JS-rendered markup ---------- */
  function icon(name, size) {
    var s = size || 20;
    var paths = {
      bag: '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/>',
      trash: '<path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>',
      minus: '<path d="M5 12h14"/>',
      plus: '<path d="M5 12h14"/><path d="M12 5v14"/>',
    };
    return '<svg xmlns="http://www.w3.org/2000/svg" width="' + s + '" height="' + s +
      '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      (paths[name] || "") + "</svg>";
  }
  function placeholder() {
    return '<div class="placeholder">' + icon("bag", 28) + "</div>";
  }
  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (m) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m];
    });
  }

  /* prime the count on load */
  refreshCart();
})();
